import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

import Input from 'components/shared/Input'

interface IProps {
  login: () => void
}

const PasswordResetSuccessScreen = ({ login }: IProps) => (
  <Grid container direction="column" spacing={3} style={{ backgroundColor: '#fff' }}>
    <Box p={{ xs: 2, md: 4, lg: 6 }}>
      <Grid item>
        <Typography variant="h4" color="secondary">
          Password reset!
        </Typography>
      </Grid>
      <Grid item>
        <Box mt={{ xs: 2, md: 5 }}>
          <Button fullWidth variant="contained" onClick={login}>
            <Typography variant="h4" color="primary">
              Go to Login
            </Typography>
          </Button>
        </Box>
      </Grid>
    </Box>
  </Grid>
)

export default PasswordResetSuccessScreen
